import React, { ReactElement } from 'react';
import { PrivateDotIcon, PublicDotIcon, RenderDotsWrapper, SmallDotIcon } from '../../../../common/CommonStyle';

interface Photo {
  id: number;
  hash_id: string;
  path: string;
  status: string;
  private: boolean;
  is_avatar: boolean;
  type: string;
  urls: {
    resized: string;
    '720px': string;
    '820px': string;
  };
  created_dt: {
    date: string;
    timezone_type: number;
    timezone: string;
  };
  approved_by: string;
  approved_dt: string;
  denied_dt: string;
  denied_reason: string;
}

const OneTapSwipeOfferMediaRenderDots = React.forwardRef(
  (
    {
      item,
      index,
      currentSlide,
      photos,
    }: {
      item: Photo;
      index: number;
      currentSlide: number;
      photos: Photo[];
    },
    ref
  ): ReactElement => {
    const activeDot = currentSlide === index;
    const lastDotSmall = photos.length >= 4 && index > currentSlide + 2;
    const hideDots = photos.length >= 4 && (index > currentSlide + 3 || index < currentSlide - 3);
    const firstDotSmall = photos.length >= 4 && index < currentSlide - 2;

    const renderDots = () => {
      if (lastDotSmall || firstDotSmall) {
        return hideDots ? <></> : <SmallDotIcon key={`small-${index}-${item.path}`} isPublic={!item.private} />;
      } else if (!item.private) {
        return <PublicDotIcon key={`public-${index}-${item.id}`} activeDot={activeDot} />;
      } else {
        return <PrivateDotIcon key={`private-${index}-${item.id}`} activeDot={activeDot} />;
      }
    };

    return (
      <RenderDotsWrapper
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        ref={ref}
        hideDots={hideDots}
        key={`${item.hash_id}_${index}`}
        data-test-id={`${item.hash_id}_${index}`}
      >
        {renderDots()}
      </RenderDotsWrapper>
    );
  }
);

export default OneTapSwipeOfferMediaRenderDots;
